<template>
    <div class="share">
        <h4>Siga-nos e partilhe:</h4>
        <div class="icons">
            <a :href="email">
                <img src="@/assets/images/share-email.svg" alt="">
            </a>
            <a :href="facebook">
                <img src="@/assets/images/share-facebook.svg" alt="">
            </a>
            <a :href="twitter">
                <img src="@/assets/images/share-twitter.svg" alt="">
            </a>
            <a :href="linkedin">
                <img src="@/assets/images/share-linkedin.svg" alt="">
            </a>
            <a :href="pinterest">
                <img src="@/assets/images/share-pinterest.svg" alt="">
            </a>
            <a :href="telegram">
                <img src="@/assets/images/share-telegram.svg" alt="">
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShareButtons',
        props: {
            post: {required: true}
        },
        computed: {
            email() {
                return `mailto:info@example.com?&subject=&cc=&bcc=&body=${this.url}`
            },
            facebook() {
                return `https://www.facebook.com/sharer/sharer.php?u=${this.url}`
            },
            twitter() {
                return `https://twitter.com/intent/tweet?url=${this.url}&text=`
            },
            linkedin() {
                return `https://www.linkedin.com/shareArticle?mini=true&url=${this.url}`
            },
            pinterest() {
                return `https://pinterest.com/pin/create/button/?url=${this.url}&media=&description=`
            },
            telegram() {
                return `https://t.me/share/url?url=${this.url}&text=`
            },
            url() {
                return encodeURIComponent(`${window.location.origin}${this.post.link}`)
            },
        },
    }
</script>

<style lang="scss" scoped>
@import "@/assets/scss/fonts";
.share {
    margin-top: 1rem;

    h4 {
        text-transform: uppercase;
        font-family: $ff-headings;
    }

    .icons {
        display: flex;
        gap: 1rem;

        a {
            display: block;
            width: fit-content;
            height: fit-content;
        }
    }
}
</style>
